import { Box, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useResourceTemplatesQuery } from '../../admin/templates/resources/resources';
import { StepsIndexConstant } from '../../common/components/Stepper';
import { useStepper } from '../../common/components/StepperContext';
import { FormProvider } from '../../common/form/FormContext';
import FormModalInfoAlert from '../../common/form/FormModalInfoAlert';
import FormPanel from '../../common/form/FormPanel';
import Validator from '../../common/form/Validator';
import I18n from '../../common/i18n/I18n';
import { useStyling } from '../../common/Theme';
import ResourceChooseCreateSection from './ResourceChooseCreateSection';
import ResourceTypeFormItem from './ResourceTypeFormItem';

export default ({ existingType, isHireResource = false }: { existingType?: string; isHireResource?: boolean }) => {
    const { theme } = useStyling();
    const { getStepData, activeStep, getTemplateData, setTemplateData } = useStepper();

    const templateData = getTemplateData(StepsIndexConstant.zero);
    const { resourceTemplatesData, isResourceTemplatesDataLoading } = useResourceTemplatesQuery(!isEmpty(templateData));

    const currentStepData = getStepData(activeStep);
    const isEdit = existingType;
    const [values, setValues] = useState({ type: currentStepData?.type || existingType });

    useEffect(() => {
        if (resourceTemplatesData?.results?.hits?.items) {
            setTemplateData(StepsIndexConstant.zero, resourceTemplatesData.results.hits.items);
        }
    }, [resourceTemplatesData?.results?.hits?.items, setTemplateData]);

    return (
        <FormProvider state={values} setState={setValues} validationRules={{ type: [Validator.RULES.isRequired] }}>
            <FormPanel>
                <FormModalInfoAlert sx={{ p: 0 }}>
                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                        <I18n token="stepper.resource.type.info.description" />
                        <Typography
                            sx={{ fontSize: theme.typography.subtitle2, fontWeight: theme.typography.fontWeightBold }}
                        >
                            <I18n token="stepper.resource.type.info.description.pick.type" />
                        </Typography>
                    </Box>
                </FormModalInfoAlert>
                <ResourceTypeFormItem isHireResource={isHireResource} />
                {!isEdit && !isResourceTemplatesDataLoading && (
                    <ResourceChooseCreateSection
                        isHireResource={isHireResource}
                        isResourceTemplatesDataLoading={isResourceTemplatesDataLoading}
                    />
                )}
            </FormPanel>
        </FormProvider>
    );
};
